import React from 'react';
import PlanCard from './PlanCard';

const PlanSelection = ({ 
  plans, 
  selectedPlan, 
  onSelectPlan, 
  billingCycle, 
  onBillingCycleChange, 
  currentLanguage 
}) => {
  const content = {
    fr: {
      monthly: 'Mensuel',
      annual: 'Annuel',
      billingCycle: 'Cycle de facturation'
    },
    ar: {
      monthly: 'شهري',
      annual: 'سنوي',
      billingCycle: 'دورة الفوترة'
    }
  };

  const text = content?.[currentLanguage];

  return (
    <div className="space-y-6 md:space-y-8">
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
        <span className="text-sm font-medium text-muted-foreground">
          {text?.billingCycle}
        </span>
        <div className="inline-flex rounded-lg bg-muted p-1">
          <button
            onClick={() => onBillingCycleChange('monthly')}
            className={`
              px-4 md:px-6 py-2 rounded-md text-sm font-medium transition-all duration-300
              ${billingCycle === 'monthly' ?'bg-background text-foreground shadow-warm' :'text-muted-foreground hover:text-foreground'
              }
            `}
          >
            {text?.monthly}
          </button>
          <button
            onClick={() => onBillingCycleChange('annual')}
            className={`
              px-4 md:px-6 py-2 rounded-md text-sm font-medium transition-all duration-300
              ${billingCycle === 'annual' ?'bg-background text-foreground shadow-warm' :'text-muted-foreground hover:text-foreground'
              }
            `}
          >
            {text?.annual}
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
        {plans?.map((plan) => (
          <PlanCard
            key={plan?.id}
            plan={plan}
            isSelected={selectedPlan === plan?.id}
            onSelect={onSelectPlan}
            currentLanguage={currentLanguage}
            billingCycle={billingCycle}
          />
        ))}
      </div>
    </div>
  );
};

export default PlanSelection;